// extracted by mini-css-extract-plugin
export default {"main":"theme_main__70Xa7","content":"theme_content__+xXFc"};